import { useLazyQuery } from "@apollo/client/react";
import Box from '@mui/material/Box';
import { useEffect, useState } from 'react';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { SelectInput } from '../../../components/selectInput/SelectInput';

import toast from 'react-hot-toast';
import { GET_CONSULTA_CIERRE } from '../../../data/graphQL/queries/CierreDeVentas/ConsultaCierre';
import { GET_CONSULTA_CIERRE_AGRUPADO } from '../../../data/graphQL/queries/CierreDeVentas/ConsultaCierreAgrupado';
import { GET_CONSULTA_CIERRE_DIFERENCIA } from '../../../data/graphQL/queries/CierreDeVentas/ConsultaCierreDiferencia';
import { GET_CONSULTA_CIERRE_DIFERENCIA_AGRUPADA } from '../../../data/graphQL/queries/CierreDeVentas/ConsultaCierreDiferenciaAgrupada';
import { GET_CONSULTA_CIERRE_PENDIENTE_MES } from '../../../data/graphQL/queries/CierreDeVentas/ConsultaCierrePendienteMes';
import { GET_CONSULTA_CIERRE_VENTA_MAESTRO } from '../../../data/graphQL/queries/CierreDeVentas/ConsultaCierreVentaMaestro';
import { downloadExcelGeneric } from '../../../utils/downloadExcelGeneric';
import { adaptCierre, adaptCierreAgrupado, adaptDiferencias, adaptDiferenciasAgrupadas, adaptPendienteMes, adaptVentasMaestro } from './adaptersConsulta';

export const ConsultaSection = ({
  initialIdPeriodo,
  initialMonth,
  initialYear
}) => {
  const [tipoConsulta, setTipoConsulta] = useState(1);
  const [mes, setMes] = useState(initialMonth);
  const [anio, setAnio] = useState(initialYear);
  const [loading, setLoading] = useState(false);
  const [resultData, setResultData] = useState([]);
  const [dataReady, setDataReady] = useState(false);

  const [getCierre] = useLazyQuery(GET_CONSULTA_CIERRE, {
    fetchPolicy: 'no-cache'
  });
  const [getVentasMaestro] = useLazyQuery(GET_CONSULTA_CIERRE_VENTA_MAESTRO, {
    fetchPolicy: 'no-cache'
  });
  const [getCierreAgrupado] = useLazyQuery(GET_CONSULTA_CIERRE_AGRUPADO, {
    fetchPolicy: 'no-cache'
  });
  const [getPendienteMes] = useLazyQuery(GET_CONSULTA_CIERRE_PENDIENTE_MES, {
    fetchPolicy: 'no-cache'
  });
  const [getDiferencias] = useLazyQuery(GET_CONSULTA_CIERRE_DIFERENCIA, {
    fetchPolicy: 'no-cache'
  });
  const [getDiferenciasAgrupadas] = useLazyQuery(GET_CONSULTA_CIERRE_DIFERENCIA_AGRUPADA, {
    fetchPolicy: 'no-cache'
  });

  const generarOpcionesAnios = () => {
    const anioActual = new Date().getFullYear();
    const anioInicio = 2018;
    const anios = [];

    for (let i = anioInicio; i <= anioActual; i++) {
      anios.push({ id: i, displayName: i.toString() });
    }

    return anios;
  };

  const opcionesMeses = [
  { id: 1, displayName: 'Enero' },
  { id: 2, displayName: 'Febrero' },
  { id: 3, displayName: 'Marzo' },
  { id: 4, displayName: 'Abril' },
  { id: 5, displayName: 'Mayo' },
  { id: 6, displayName: 'Junio' },
  { id: 7, displayName: 'Julio' },
  { id: 8, displayName: 'Agosto' },
  { id: 9, displayName: 'Septiembre' },
  { id: 10, displayName: 'Octubre' },
  { id: 11, displayName: 'Noviembre' },
  { id: 12, displayName: 'Diciembre' }];


  const tiposConsulta = [
  {
    id: 1,
    displayName: 'Cierre',
    entityName: 'consultaCierre',
    query: getCierre,
    adapter: adaptCierre
  },
  {
    id: 2,
    displayName: 'Ventas Maestro',
    entityName: 'consultaCierreVentaMaestro',
    query: getVentasMaestro,
    adapter: adaptVentasMaestro
  },
  {
    id: 3,
    displayName: 'Cierre Agrupados',
    entityName: 'consultaCierreAgrupado',
    query: getCierreAgrupado,
    adapter: adaptCierreAgrupado
  },
  {
    id: 4,
    displayName: 'Pendientes Mes',
    entityName: 'consultaCierrePendienteMes',
    query: getPendienteMes,
    adapter: adaptPendienteMes
  },
  {
    id: 5,
    displayName: 'Diferencias',
    entityName: 'consultaCierreDiferencia',
    query: getDiferencias,
    adapter: adaptDiferencias
  },
  {
    id: 6,
    displayName: 'Diferencias Agrupadas',
    entityName: 'consultaCierreDiferenciaAgrupada',
    query: getDiferenciasAgrupadas,
    adapter: adaptDiferenciasAgrupadas
  }];


  const opcionesTipoConsulta = tiposConsulta.map(({ id, displayName }) => ({
    id,
    displayName: displayName
  }));

  useEffect(() => {
    if (tipoConsulta === null && tiposConsulta.length > 0) {
      setTipoConsulta(tiposConsulta[0].id);
    }
  }, [tipoConsulta, tiposConsulta]);

  useEffect(() => {
    if (dataReady && resultData.length > 0) {
      realizarDescarga();
      setDataReady(false);
    }
  }, [dataReady, resultData]);

  const ejecutarConsulta = async () => {
    if (!tipoConsulta) return null;

    setLoading(true);

    const tipoSeleccionado = tiposConsulta.find((item) => item.id === tipoConsulta);

    if (!tipoSeleccionado) {
      console.error("Tipo de consulta no encontrado");
      setLoading(false);
      return null;
    }

    const { query, entityName, adapter } = tipoSeleccionado;

    try {
      const response = await query({ variables: { mes, anio } });
      const rawData = (response?.data?.[entityName]?.valorEsperado || []).map((item) => adapter(item));

      if (!rawData?.length) throw new Error("No se encontraron datos para la consulta");

      setResultData(rawData);
      return rawData;

    } catch (error) {
      setResultData([]);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const realizarDescarga = () => {
    if (resultData && resultData.length > 0) {
      const nombreConsulta = opcionesTipoConsulta.find((opt) => opt.id === tipoConsulta)?.displayName || 'Consulta';
      const nombreMes = opcionesMeses.find((m) => m.id === mes)?.displayName || '';

      const resultDataFormatted = resultData.map(({ __typename, ...row }) => row);

      downloadExcelGeneric({
        fileName: `${nombreConsulta}_${nombreMes}_${anio}`,
        sheet: "Datos",
        tablePayload: {
          body: resultDataFormatted
        }
      });
    } else {
      throw new Error("No hay datos para descargar");
    }
  };

  const handleDescargarAlt = async () => {
    toast.promise(
      (async () => {
        try {
          await ejecutarConsulta();
          setDataReady(true);
          return true;
        } catch (error) {
          console.error("Error al descargar:", error);
          throw error;
        }
      })(),
      {
        loading: 'Consultando datos...',
        success: 'Datos descargados correctamente',
        error: 'No se encontraron resultados para la fecha seleccionada'
      }
    );
  };

  return (
    <div>
            <h3>Consultar</h3>
            <div className="cierre-ventas-section">
                <h3>Resultado de la Consulta</h3>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
                    <SelectInput
            options={opcionesTipoConsulta}
            label={'Tipo de consulta'}
            onChange={(e) => setTipoConsulta(parseInt(e.target.value))}
            value={tipoConsulta || ''}
            fullWidth={false}
            sx={{ width: '300px' }} />
          
                    <SelectInput
            options={opcionesMeses}
            label={'Mes'}
            onChange={(e) => setMes(parseInt(e.target.value))}
            value={mes}
            fullWidth={false}
            sx={{ width: '200px' }} />
          
                    <SelectInput
            options={generarOpcionesAnios()}
            label={'Año'}
            onChange={(e) => setAnio(parseInt(e.target.value))}
            value={anio}
            fullWidth={false}
            sx={{ width: '150px' }} />
          
                    <CustomButton
            label='Descargar'
            onClick={handleDescargarAlt}
            disabled={loading || !tipoConsulta} />
          
                </Box>
            </div>
        </div>);

};